import styled from "@emotion/styled";
import theme from "@theme/";

const CardContainerStyle = styled.div`
  margin: 10px;
  padding: 5px 10px 5px 10px;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 8px;
`;

const SC = {
  CardContainerStyle,
};

export default SC;
